<template>
  <div class="">
    <template v-for="(m, index) in mopList">
    <div v-bind:key="index">
      <div class="mb-3"><h5>{{index}}</h5></div>
        <draggable
          :group="index"
          v-model="mopList[index]"
          draggable=".mod-item"
          @end="updateOrder"
          class="d-flex flex-wrap"
        >
          <mop-module-item
            v-for="(n, idx) in m"
            class="mod-item"
            @edit="
              () =>
                $router.push({
                  name: 'ModuleModeForm',
                  params: { methodId: n.methodId, mode: 'edit' },
                })
            "
            @delete="deactivate(n)"
            @toggleStatus="toggleStatus(n)"
            v-bind:mopModule="n"
            v-bind:key="idx"
          />
        </draggable>
      <hr />
    </div>
    </template>

   
  </div>
</template>

<script>
import MopModuleItem from "@/views/pages/mode-of-payment/MopModuleItem.vue";
import { layoutMethods, mopMethods, mopComputed } from "@/state/helpers";
import Swal from "sweetalert2";
import { getModuleAccess, showAccessRestrictedModal } from '@/router/helper.js';
import draggable from 'vuedraggable';
import _ from 'lodash';

export default {
  data(){
    return {
      mopList: [],
      unlockReason: [
        "Completed Maintenance",
        "Resolved Bugs/Issue",
        "Resolved Fraud Investigation",
      ],
      lockReason: [
        "Maintenance",
        "Bugs/Issue",
        "Change in Business Strategy",
        "Fraud Investigation"
      ],
      modesOfPaymentModule: {
				access: {
					create: false,
          read: false,
          update: false,
          delete: false
				}
			}
    }
  },
  components: {
    MopModuleItem,
    draggable
  },
  computed: {
    ...mopComputed
  },
  methods: {
    ...layoutMethods,
    ...mopMethods,
    endHtml(status, module){
      var statustxt = 'enable';
      var reasons = [];
      if(status == 'a'){
        reasons = this.unlockReason;
      } else if(status == 'i'){
        reasons = this.lockReason;
        statustxt = 'disable';
      }
      var titleDiv = `<div class="mb-4">This will ${statustxt} this payment mode in ${module}.</div>`;
      var selectOne = '<select id="mop-remarks" class="form-control" >'
      selectOne += '<option value="" disabled selected>Select reason</option>'
      reasons.forEach(r => {
        selectOne += `<option value="${r}">${r}</option>`
      });
      selectOne += "</select>";
      var divOne = '<div class="mb-4">'+selectOne+'</div>';

      var html = `<div>${titleDiv}${divOne}</div>`
      return html;
    },
    updateOrder(){
      var orderData = [];
      
      for (const [key, value] of Object.entries(this.mopList)) {
        console.log(`${key}: ${value}`);
        for(const idx in value){
          orderData.push({
            id: value[idx].methodId,
            sequence: idx
          })
        }
      }

      this.updateModuleOrder(orderData);
    },
    deleteHtml(mopName = ''){
      var titleDiv = `<div class="mb-4">Are you sure you want to delete this ${mopName} module?<br/>This process cannot be undone</div><div class="mb-4">Please provide a reason for the deletion:</div>`;
      var inputOne = '<label class="w-100 text-start form-label small fw-bold">Reason<span class="text-danger">*</span></label><input maxlength="50" id="mop-mod-delete-remarks" placeholder="Enter reason" class="form-control" ><div class="character-count text-end mt-2"><span id="mop-mod-character-count">0</span>/50</div>'
      var divOne = '<div class="mb-4">'+inputOne+'</div>';

      var html = `<div>${titleDiv}${divOne}</div>`
      return html;
    },
    deactivate(mop) {
      if (this.modesOfPaymentModule.access.delete) {
        Swal.fire({
          title: "Are you sure?",
          text: `Do you really want to delete this module? This process cannot be undone.`,
          icon: "question",
          html: this.deleteHtml(mop.displayName),
          showCancelButton: true,
          confirmButtonColor: "#6E66D9",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: "Confirm",
          cancelButtonText: "No",
          preConfirm: function(){
            if(!document.getElementById('mop-mod-delete-remarks').value){
              Swal.showValidationMessage("Please input reason");  
            }
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteMopModule({
              methodId: mop.methodId,
              reason: document.getElementById('mop-mod-delete-remarks').value
            })
              .then(() => {
                Swal.fire(
                  "Module Delete Successful!",
                  `${mop.displayName} Module has been deleted.`,
                  "success"
                );
                this.listMopModules().then(() => {
                  this.mopList = _.cloneDeep(this.mopModules)
                });
              })
              .catch((e) => {
                Swal.fire("Delete Failed!", `An Error Occured: ${e}`, "error");
              });
          } else {
            return;
          }
        });

        document.getElementById('mop-mod-delete-remarks').addEventListener('input', function (){
          var length = document.getElementById('mop-mod-delete-remarks').value.length;
          document.getElementById('mop-mod-character-count').innerHTML = length;
        });
      } else {
        showAccessRestrictedModal();
      }
    },
    toggleStatus: function(md){
      var oldStatus = md.mdStatus == 'a' ? 'i' : 'a';
      Swal.fire({
          title: 'Are you sure?',
          html: this.endHtml(md.mdStatus, md.moduleName),
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '##804997',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          preConfirm: function(){
            if(!document.getElementById('mop-remarks').value){
              Swal.showValidationMessage("Please select reason");  
            }
          }
      }).then((result) => {
          if (result.isConfirmed) {
            
            this.updateMopMethodStatus({
              methodId: md.methodId,
              status: md.mdStatus == 'a',
              reason: document.getElementById('mop-remarks').value
            })
              .then(() => {
                Swal.fire(
                  "Update Successful!",
                  `MOP was updated`,
                  "success"
                );
              })
              .catch(err => {
                md.mdStatus = oldStatus;
                Swal.fire(
                  "Update Failed!",
                  err.message? err.message : `MOP was not updated.`,
                  "error"
                );
              });
          } else{
            md.mdStatus = oldStatus;
          }
      })
    }
  },
  async mounted() {
    this.listMopModules().then(() => {
      this.mopList = _.cloneDeep(this.mopModules)
    });

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Settings', 'Modes of Payment')
      .then((access) => this.modesOfPaymentModule.access = access);
  },
};
</script>

<style>
</style>